import React from 'react'
import estilos from './ArchivoComponent.module.css'
import Tooltip from '@mui/material/Tooltip';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../redux/AppDucks';
import { useDispatch } from 'react-redux'
//10MB
const MAXIMO_TAMANIO_BYTES = 40000000; // 1MB = 1 millon de bytes

export const ArchivoComponent = (props) => {
    const dispatch = useDispatch()

    const { textLabel, span, name, id, api, textoTooltip, idAnexo = undefined,
        filesMap = undefined, comprobantepago = undefined, comprobantepagotext = undefined,
        idAnexoFK = undefined } = props
    const { handdleFile, handdleRemovePrev, files } = api
    const [isFilePicked, setIsFilePicked] = React.useState(false)
    const [fileLocal, setFileLocal] = React.useState({ id: null, file: null, estatus: null })
    const [fileError, setFileError] = React.useState('')
    const [idFileBD, setIdFileBD] = React.useState(null)
    const [classStyleChek, setClassStyleChek] = React.useState(undefined)
    const [observaciones, setObservaciones] = React.useState(undefined)

    const handleFileChangue = async (e) => {
        if (e.target.files[0] !== undefined) {
            if (e.target.files[0].type === 'application/pdf') {

                if (e.target.files[0].size > MAXIMO_TAMANIO_BYTES) {
                    setFileError('Selecciona un archivo menor a 30 MB')
                }
                else {
                    setFileError('')
                    await dispatch(actualizarLoadingApp_true())
                    if (fileLocal.id === null) {
                        const result = await handdleFile({ id: id, idAnexo: idAnexo, file: e.target.files[0], idAnexoFK: idAnexoFK, estatus: false })
                        if (result) {
                            setFileLocal({ id: id, idAnexo: idAnexo, file: e.target.files[0], idAnexoFK: idAnexoFK, estatus: result })
                        } else {
                            setFileLocal({ id: null, idAnexo: idAnexo, file: null, idAnexoFK: idAnexoFK, estatus: result })
                        }
                        setIsFilePicked(true)
                    } else {
                        const result = handdleRemovePrev({ id: id, idAnexo: fileLocal.idAnexo, file: e.target.files[0], idAnexoFK: idAnexoFK, estatus: fileLocal.estatus })
                        if (result) {
                            setFileLocal({ id: id, idAnexo: idAnexo, file: e.target.files[0], idAnexoFK: idAnexoFK, estatus: result })
                        } else {
                            setFileLocal({ id: fileLocal.id, idAnexo: fileLocal.idAnexo, file: fileLocal.file, idAnexoFK: idAnexoFK, estatus: result })
                        }
                        setIsFilePicked(true)
                    }
                    await dispatch(actualizarLoadingApp_false())
                }

            } else {
                setFileError('Seleccione un archivo en formato PDF')
            }

        }
    }

    const handleSetFileLocalFromParent = () => {
        files.map((file, index) => {

            if (file.id === id) {

                setFileLocal({ id: file.id, idAnexo: file.idAnexo, file: file.file, idAnexoFK: file.idAnexoFK, estatus: file.estatus })
                setIsFilePicked(true)
                if (file.idAnexo && filesMap) {

                    const fileMap = filesMap.filter(field => field.idAnexoBD === file.idAnexo)

                    if (fileMap[0]) {
                        if (fileMap[0].nameidcheck !== undefined) {
                            setClassStyleChek(fileMap[0].nameidcheck)
                            if (fileMap[0].nameidcheck === true) setObservaciones(fileMap[0].nameid)
                        }
                        else if (fileMap[0].estatuscheck !== undefined) {
                            setClassStyleChek(fileMap[0].estatuscheck)
                            if (fileMap[0].estatuscheck === true) setObservaciones(fileMap[0].observacion)
                        }
                    }
                    // setIdFileBD(file.idAnexoBD)
                }
            }
        })
    }

    React.useEffect(() => {
        setFileLocal(({ id: null, file: null, estatus: null }))
        setIsFilePicked(false)
        handleSetFileLocalFromParent()
    }, [files])



    return (
        <div className='row mb-3'>
            <br />
            {/* {
                isFilePicked && (
                    <div>
                        <p>Nombre de archivo: {fileLocal?.file.name}</p>
                        <p>Tipo de archivo: {fileLocal?.file.type}</p>
                    </div>
                ) 
            } */}
            <div className='col-md-3 ms-5'>

                {
                    textoTooltip !== undefined ?
                        <Tooltip title={`${textoTooltip}`} arrow>
                            <label className="form-label border-secondary textoParaArchivos">{textLabel}</label>
                        </Tooltip>
                        :
                        <label className="form-label border-secondary textoParaArchivos">{textLabel}</label>
                }
            </div>

            <div className={`col-md-3  ${estilos.archivo}`}>
                <label className={`${classStyleChek !== undefined ? (classStyleChek ? estilos.inputDenegado
                    : estilos.inputValidado) : ('')} ${(comprobantepago !== undefined && comprobantepago !== '') ? (comprobantepago ? estilos.inputDenegado : estilos.inputValidado) : ''}`} htmlFor={id}>Seleccionar archivo</label>

                <input
                    className={`form-control ${classStyleChek
                        !== undefined ? (classStyleChek ? 'inputDenegado'
                            : 'inputValidado') : ('')}`}
                    type="file" name={name} id={id} onChange={handleFileChangue}
                    accept="application/pdf"></input>
                <br />
                <span className='text-danger'>{span}</span>
            </div>
            <div className='col-md-5'>
                {
                    isFilePicked ? (
                        < div className='row'>
                            <div className='col-md-11'>
                                <label className={`${estilos.labelArchivo} ${classStyleChek !== undefined ? (classStyleChek ? estilos.inputDenegado
                                    : estilos.inputValidado) : ('')} ${(comprobantepago !== undefined && comprobantepago !== '') ? (comprobantepago ? estilos.inputDenegado : estilos.inputValidado) : ''}`} htmlFor={id}>{fileLocal.estatus === true ? (fileLocal?.file?.name)?.substring(0, 33) : "Ninguno archivo seleccionado"}</label>
                            </div>
                            <div className='col-md-1'>
                                {
                                    fileLocal.estatus === true &&
                                    <button className={true ? ('btn btn-success') : ('btn btn-outline-success')}>✓</button>
                                }
                                {
                                    fileLocal.estatus === false &&
                                    <button className={true ? ('btn btn-danger') : ('btn btn-outline-danger')}>X</button>
                                }
                            </div>
                            {
                                (fileLocal.estatus === false) &&
                                <span className='text-danger'>Campo obligatorio</span>
                            }
                        </div>
                    ) :
                        (
                            <>
                                <label className={`${estilos.labelArchivo} ${(comprobantepago !== undefined && comprobantepago !== '') ? (comprobantepago ? estilos.inputDenegado : estilos.inputValidado) : ''}`} htmlFor={id}>Ninguno archivo seleccionado</label>
                                {
                                    (fileError === '' && id !== 'DGCP') &&
                                    <span className='text-danger'>Campo obligatorio</span>
                                }

                            </>
                        )
                }
                {/* <button className={true ? ('btn btn-success ms-5') : ('btn btn-outline-success ms-5')}>✓</button> */}
                {/* <button className={true ? ('btn btn-danger ms-3') : ('btn btn-outline-danger ms-3')}>X</button> */}
                {
                    fileError !== '' &&
                    <span className='text-danger'>{fileError}</span>
                }
                {
                    observaciones !== undefined &&
                    <span className={`${classStyleChek ? 'text-danger' : 'text-success'} `}>{`${observaciones}`}</span>
                }
                {
                    (comprobantepago === true && comprobantepagotext !== null) &&
                    <span className='text-danger'>{`${comprobantepagotext}`}</span>
                }
            </div>
        </div>
    )
}

